import { render, staticRenderFns } from "./group-1.vue?vue&type=template&id=2b7f21e8&scoped=true&"
import script from "./group-1.vue?vue&type=script&lang=js&"
export * from "./group-1.vue?vue&type=script&lang=js&"
import style0 from "./group-1.vue?vue&type=style&index=0&id=2b7f21e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f21e8",
  null
  
)

export default component.exports